import { Locale } from "@src/context/attributeConfig/AttributeConfigContext";
import { loadMessagesForLanguages } from "@src/utils/localization/remoteTranslations.utils";
import { useCallback, useEffect, useState } from "react";

export const useRemoteTranslations = (locale: Locale) => {
    const [messages, setMessages] = useState<undefined | Record<string, string>>(undefined);
    const [loading, setLoading] = useState(true);

    const intlUrl = process.env.INTL_URL;

    const loadMessages = useCallback(async () => {
        if (!intlUrl) {
            setLoading(false);

            return;
        }

        setLoading(true);

        // always load default messages
        const defaultMessages = await loadMessagesForLanguages(
            Locale.EN,
            intlUrl,
            ["spare-parts-finder-component", "DealerHUB_Common_Frontend"],
            Object.values(Locale),
        ).then((data) => {
            return data;
        });

        if (locale === Locale.EN) {
            setMessages(defaultMessages);
        } else {
            const currentLanguageMessages = await loadMessagesForLanguages(
                locale,
                intlUrl,
                ["spare-parts-finder-component", "DealerHUB_Common_Frontend"],
                Object.values(Locale),
            );
            setMessages({ ...defaultMessages, ...currentLanguageMessages });
        }
        setLoading(false);
    }, [intlUrl, locale]);

    useEffect(() => {
        void loadMessages();
    }, [loadMessages]);

    return { loading, messages: messages };
};
